import styled from 'styled-components';

export const Section = styled.section`
  padding: var(--spacing-xl) 0;
  position: relative;
  overflow: hidden;
  
  ${props => props.dark && `
    background-color: var(--primary-dark);
    color: var(--light-text);
  `}
  
  ${props => props.gradient && `
    background: ${props.gradient};
  `}
`;

export const Container = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
`;

export const FlexContainer = styled.div`
  display: flex;
  
  ${props => props.direction && `flex-direction: ${props.direction};`}
  ${props => props.justify && `justify-content: ${props.justify};`}
  ${props => props.align && `align-items: ${props.align};`}
  ${props => props.wrap && `flex-wrap: ${props.wrap};`}
  ${props => props.gap && `gap: ${props.gap};`}
  
  @media (max-width: 768px) {
    flex-direction: ${props => props.$mobileDirection || 'column'};
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.columns || 3}, 1fr);
  gap: ${props => props.gap || 'var(--spacing-lg)'};
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(${props => props.tabletColumns || 2}, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(${props => props.mobileColumns || 1}, 1fr);
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: var(--card-shadow);
  padding: var(--spacing-lg);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--card-shadow-hover);
  }
`;

export const Button = styled.button`
  background: ${props => props.secondary ? 'transparent' : 'var(--primary)'};
  color: ${props => props.secondary ? 'var(--primary)' : 'white'};
  border: ${props => props.secondary ? '2px solid var(--primary)' : 'none'};
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-block;
  text-align: center;
  
  &:hover {
    background: ${props => props.secondary ? 'var(--primary)' : 'var(--primary-dark)'};
    color: white;
  }
  
  ${props => props.large && `
    padding: 1rem 2rem;
    font-size: 1.1rem;
  `}
`;

export const SectionTitle = styled.h2`
  position: relative;
  margin-bottom: var(--spacing-xl);
  text-align: ${props => props.align || 'center'};
  
  &:after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: ${props => props.align === 'left' ? '0' : '50%'};
    transform: ${props => props.align === 'left' ? 'none' : 'translateX(-50%)'};
    width: 80px;
    height: 4px;
    background: var(--accent);
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto var(--spacing-xl);
  text-align: ${props => props.align};
  color: ${props => props.$dark ? 'var(--light-text)' : 'var(--neutral-gray)'};
`;

export const AnimatedElement = styled.div`
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  
  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
`;
